import {Outlet, createRootRouteWithContext} from '@tanstack/react-router'

import NotFound from '@components/NotFound'

import type {IUserContextValue} from '@contexts/UserContext'

export const Route = createRootRouteWithContext<{auth: IUserContextValue}>()({
  component: Outlet,
  notFoundComponent: NotFound,
})
